import { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

interface Props {
  className?: string;
}

export const IconPlus16 = forwardRef<SVGSVGElement, Props>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
  >
    <path
      d="M8 3V13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 8H13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconPlus16.displayName = 'IconPlus16';
